import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Departments from "../pages/AccessControl/pages/Department/Departments";
import Employees from "../pages/AccessControl/pages/Staff/Employees";
import Permissions from "../pages/AccessControl/pages/Permission/Permissions";
import ProtectedRoutes from "../auth/ProtectedRoutes";
import Roles from "../pages/AccessControl/pages/Role/Roles";
import DepartmentDetail from "../pages/AccessControl/pages/Department/DepartmentDetail";
import useAuth from "../hooks/useAuth";
import EmployeeDetail from "../pages/AccessControl/pages/Staff/EmployeeDetail";
import { AccessControlDetail } from "../pages/AccessControl/pages/Routes/AccessControlDetail";
import NotFound from "../pages/NotFound";
import SystemRoutes from "../auth/SystemRoutes";
import RoleAction from "../pages/AccessControl/pages/Role/RoleAction";
import EmployeeAction from "../pages/AccessControl/pages/Staff/EmployeeAction";
import AccessControl from "../pages/AccessControl/pages/Routes/AccessControl";
import Devices from "../pages/Cms/pages/Device/Devices";
import DeviceDetail from "../pages/Cms/pages/Device/DeviceDetail";
import FLFDevice from "../pages/FPTLife/pages/FLFDevice/FLFDevice";
import FLFCategories from "../pages/FPTLife/pages/FLFCategories/FLFCategories";
import FLFDeviceAction from "../pages/FPTLife/pages/FLFDevice/FLFDeviceAction";
import EmployeeChangePassword from "../pages/AccessControl/pages/Staff/EmployeeChangePassword";
import { getLocalUser, setLocalUser } from "../utils/helper";
import FLFIconAction from "../pages/FPTLife/pages/FLFIcon/FLFIconAction";
import FLFIcon from "../pages/FPTLife/pages/FLFIcon/FLFIcon";
import AdministrativeBoundaries from "../pages/AdministrativeBoundaries/pages/AdministrativeBoundaries";
import FLFIotPartner from "../pages/FPTLife/pages/FLFIotPartner/FLFIotPartner";
import FLFRogoDevSubType from "../pages/FPTLife/pages/FLFRogoDevSubType/FLFRogoDevSubType";
import FLFPairingType from "../pages/FPTLife/pages/FLFPairingType/FLFPairingType";
import { path } from "../constants/path";
import FLFContext from "../pages/FPTLife/pages/FLFContext/FLFContext";
import FLFContextDetail from "../pages/FPTLife/pages/FLFContext/FLFContextDetail";
import ReleaseGroup from "../pages/VersionRelease/pages/ReleaseGroup/ReleaseGroup";
import ReleaseOperatingSystem from "../pages/VersionRelease/pages/ReleaseOperatingSystem/ReleaseOperatingSystem";
import ReleaseAppVersion from "../pages/VersionRelease/pages/ReleaseAppVersion/ReleaseAppVersion";
import ReleaseSpeakerVersion from "../pages/VersionRelease/pages/ReleaseSpeakerVersion/ReleaseSpeakerVersion";
import ReleaseTypeSpeaker from "../pages/VersionRelease/pages/ReleaseTypeSpeaker/ReleaseTypeSpeaker";
import TTSIntent from "../pages/TTS/pages/TTSIntent/TTSIntent";
import TTSEvent from "../pages/TTS/pages/TTSEvent/TTSEvent";
import TTSContext from "../pages/TTS/pages/TTSContext/TTSContext";
import TTSContextSlot from "../pages/TTS/pages/TTSContext/TTSContextSlot";
import ReleaseGroupProDeviceAction from "../pages/VersionRelease/pages/ReleaseGroup/ReleaseGroupProDeviceAction";
import FLFCustomer from "../pages/FPTLife/pages/FLFCustomer/FLFCustomer";
import TTSColor from "../pages/TTS/pages/TTSColor/TTSColor";
import { getProfileEmployee } from "../apis/auth.api";
import Forbidden from "../pages/Forbidden";
import TTSIntentConfig from "../pages/TTS/pages/TTSIntent/TTSIntentConfig";
import tableLayout from "src/pages/TestPage/tableLayout";
import WhiteListDevice from "src/pages/Cms/pages/WhiteListDevice/WhiteListDevice";
import IotCalling from "src/pages/Cms/pages/IotCalling/IotCalling";
import IotCallingCampaign from "src/pages/Cms/pages/IotCallingCampaign/IotCallingCampaign";
import Re_fresh from "src/pages/AccessControl/pages/Re_fresh/Re_fresh";
import FLFQueryType from "src/pages/FPTLife/pages/FLFQuyeryType/FLFQueryType";
import FLFRogoDevType from "src/pages/FPTLife/pages/FLFRogoDevType/FLFRogoDevType";
import FLFHomeIndex from "src/pages/FPTLife/pages/FLFHomeIndex/FLFHomeIndex";
import FLFNotifyConfig from "src/pages/FPTLife/pages/FLFNotifyConfig/FLFNotifyConfig";

const Routes = () => {
  const { auth, setAuth } = useAuth();

  useEffect(() => {
    const currentUser = getLocalUser();

    if (currentUser?.id) {
      getProfileEmployee(currentUser.id, (result) => {
        localStorage.removeItem("user");
        // localStorage.setItem("user", JSON.stringify(result));
        setLocalUser(result);
        setAuth(result);
      });
    }
  }, [setAuth]);

  if (auth?.id) {
    return (
      <Switch>
        {/* Dashboard */}
        <Route path="/" exact component={Dashboard} />
        {/* System Routes */}
        <SystemRoutes path={path.systemEmployee} exact component={Employees} />
        <SystemRoutes
          path={`${path.systemEmployee}/add`}
          exact
          component={EmployeeAction}
        />
        <SystemRoutes
          path={`${path.systemEmployee}/edit/:id`}
          exact
          component={EmployeeAction}
        />
        <SystemRoutes
          path={`${path.systemEmployee}/:id`}
          exact
          component={EmployeeDetail}
        />
        <SystemRoutes
          path={path.systemAccessControl}
          component={AccessControl}
          exact
        />
        <SystemRoutes
          path={`${path.systemAccessControl}/:id`}
          component={AccessControlDetail}
        />
        <SystemRoutes path={path.systemRole} exact component={Roles} />
        <SystemRoutes
          path={`${path.systemRole}/add`}
          exact
          component={RoleAction}
        />
        <SystemRoutes
          path={`${path.systemRole}/edit/:id`}
          exact
          component={RoleAction}
        />
        <SystemRoutes
          path={`${path.systemDepartment}`}
          component={Departments}
          exact
        />
        <SystemRoutes
          path={`${path.systemDepartment}/:id`}
          component={DepartmentDetail}
        />
        <SystemRoutes path={path.systemPermission} component={Permissions} />

        <SystemRoutes
          path={`${path.systemRefresh}`}
          component={Re_fresh}
          exact
        />
        {/* Protect Routes */}
        {/* CHANGE PASSWORD */}
        <ProtectedRoutes
          path="/employee/change-password"
          exact
          component={EmployeeChangePassword}
        />
        {/* TEST ROUTES */}
        <ProtectedRoutes path="/test/table" exact component={tableLayout} />

        {/* CMS ROUTES */}
        <ProtectedRoutes
          path={path.cmsDevice}
          exact
          title="Device Page"
          component={Devices}
        />
        <ProtectedRoutes
          path={`${path.cmsDevice}/while-list`}
          exact
          component={WhiteListDevice}
        />
        <ProtectedRoutes
          path={`${path.cmsDevice}/add`}
          exact
          component={DeviceDetail}
        />
        <ProtectedRoutes
          path={`${path.cmsDevice}/edit/:id`}
          exact
          component={DeviceDetail}
        />

        <ProtectedRoutes
          path={path.cmsAdb}
          exact
          title="Administrative Boundary"
          component={AdministrativeBoundaries}
        />

        <ProtectedRoutes
          path={path.cmsIotCalling}
          exact
          title="Iot Calling Page"
          component={IotCalling}
        />

        <ProtectedRoutes
          path={path.cmsIotCallingCampaign}
          exact
          title="Iot Calling Campaign Page"
          component={IotCallingCampaign}
        />
        {/* FPT LIFE ROUTES */}
        <ProtectedRoutes path={path.flfIcon} exact component={FLFIcon} />
        <ProtectedRoutes
          path={`${path.flfIcon}/add`}
          exact
          component={FLFIconAction}
        />
        <ProtectedRoutes
          path={`${path.flfIcon}/edit/:id`}
          exact
          component={FLFIconAction}
        />
        <ProtectedRoutes path={path.flfDevice} exact component={FLFDevice} />
        <ProtectedRoutes
          path={`${path.flfDevice}/add`}
          exact
          component={FLFDeviceAction}
        />
        <ProtectedRoutes
          path={`${path.flfDevice}/edit/:id`}
          exact
          component={FLFDeviceAction}
        />

        <ProtectedRoutes
          path={path.flfCategory}
          exact
          component={FLFCategories}
        />
        <ProtectedRoutes
          path={path.flfIotPartner}
          exact
          component={FLFIotPartner}
        />

        <ProtectedRoutes
          path={path.flfRogoDevType}
          exact
          component={FLFRogoDevType}
        />
        <ProtectedRoutes
          path={path.flfRogoDevSubType}
          exact
          component={FLFRogoDevSubType}
        />

        <ProtectedRoutes
          path={path.flfQueryType}
          exact
          component={FLFQueryType}
        />
        <ProtectedRoutes
          path={path.flfHomeIndex}
          exact
          component={FLFHomeIndex}
        />
        <ProtectedRoutes
          path={path.flfCustomer}
          exact
          component={FLFCustomer}
        />
        <ProtectedRoutes
          path={path.flfPairingType}
          exact
          component={FLFPairingType}
        />
        <ProtectedRoutes path={path.flfContext} exact component={FLFContext} />
        <ProtectedRoutes
          path={`${path.flfContext}/:id`}
          exact
          component={FLFContextDetail}
        />
        <ProtectedRoutes
          path={path.flfNotifyConfig}
          exact
          component={FLFNotifyConfig}
        />

        <ProtectedRoutes
          path={`${path.releaseGroup}`}
          exact
          component={ReleaseGroup}
        />

        <ProtectedRoutes
          path={`${path.releaseGroup}/add`}
          exact
          component={ReleaseGroupProDeviceAction}
        />

        <ProtectedRoutes
          path={`${path.releaseGroup}/edit/:id`}
          exact
          component={ReleaseGroupProDeviceAction}
        />

        <ProtectedRoutes
          path={`${path.releaseOperatingSystem}`}
          exact
          component={ReleaseOperatingSystem}
        />
        <ProtectedRoutes
          path={`${path.releaseAppVersion}`}
          exact
          component={ReleaseAppVersion}
        />
        <ProtectedRoutes
          path={`${path.releaseSpeakerVersion}`}
          exact
          component={ReleaseSpeakerVersion}
        />

        <ProtectedRoutes
          path={`${path.releaseTypeSpeaker}`}
          exact
          component={ReleaseTypeSpeaker}
        />

        <ProtectedRoutes
          path={`${path.ttsIntent}`}
          exact
          component={TTSIntent}
        />

        <ProtectedRoutes path={`${path.ttsEvent}`} exact component={TTSEvent} />
        <ProtectedRoutes path={`${path.ttsColor}`} exact component={TTSColor} />
        <ProtectedRoutes
          path={`${path.ttsContext}`}
          exact
          component={TTSContext}
        />
        <ProtectedRoutes
          path={`${path.ttsContext}/slot/:id`}
          exact
          component={TTSContextSlot}
        />
        <ProtectedRoutes
          path={`${path.ttsIntent}/add`}
          exact
          component={TTSIntentConfig}
        />
        <ProtectedRoutes
          path={`${path.ttsIntent}/edit/:id`}
          exact
          component={TTSIntentConfig}
        />

        <Route
          path="/not-found"
          title="NOT FOUND PAGE"
          exact
          component={NotFound}
        />

        <Route
          path="/forbidden"
          title="Permission Denied"
          exact
          component={Forbidden}
        />
        <Route path="*" title="NOT FOUND PAGE" component={NotFound} />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route path="/" exact component={Dashboard} />
        <Redirect to="/" />
      </Switch>
    );
  }
};

export default Routes;
